<template>
  <div class="main-content">
    <section class="section">
      <!-- Breadcrumb -->
      <PageHeader
        v-if="!isMobile"
         :formData="formData" 
        :wfDtl="wfDtl"
        :gridData="gridData"
        @wfAction="wfAction"
        @wfNoteChanged="wfNoteChanged"
        :deleteList="deleteList"
        :page="this"
      >
        <template slot="buttons">
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="wfDiagramBtnClick()">
              <i class="fas fa-project-diagram mr-2"></i>Workflow Diagram
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="saveButtonClicked()">
              <i class="far fa-save"></i>Save
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-light legitRipple" @click="cancelBtnClick()">
              <i class="far fa-window-close mr-2"></i>Cancel
            </button>
          </div>
        </template>
      </PageHeader>

     <PageMobileHeader
        v-if="isMobile"
         :formData="formData" 
        :wfDtl="wfDtl"
        :gridData="gridData"
        @wfAction="wfAction"
        @wfNoteChanged="wfNoteChanged"
        :deleteList="deleteList"
        :page="this"
      >
        <template slot="buttons">
          <div class="mt-3 mt-lg-0 mr-lg-3"> 
            <button type="button" class="btn btn-primary legitRipple" @click="wfDiagramBtnClick()">
              <i class="fas fa-project-diagram mr-2"></i>Workflow Diagram
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="saveButtonClicked()">
              <i class="far fa-save mr-2"></i>Save
            </button>
          </div>
        </template>
      </PageMobileHeader>

    </section>
    <div class="section-body">
      <div class="card" style="padding-top:5px">
        <!-- {{filters[3]}} -->
        <div class="card-header">
          <h4>Workflow History</h4>
          <div id="card-action" class="card-header-action" style="max-width: 150px;">
            <h4>Status: {{wfDtl.curStep!=null?wfDtl.curStep.description:""}}</h4>
          </div>
          <template v-if="computedIcon">
            <div class="col-md-1" v-if="ticon">
              <i
                class="fas fa-chevron-down float-right align-middle btn btn-circle"
                @click="toggleIcon"
              ></i>
            </div>
            <div class="col-md-1" v-if="!ticon">
              <i
                class="fas fa-chevron-up float-right align-middle btn btn-circle"
                @click="toggleIcon"
              ></i>
            </div>
          </template>
        </div>
        <div :style="{ display: ticon ? 'block' : 'none' }">
          <div class="card-body">
            <table class="table table-bordered">
              <thead class="header-bocigrey">
                <tr>
                  <th style="width: 10%">Action</th>
                  <th style="width: 25%">Action By</th>
                  <th style="width: 15%">Received On</th>
                  <th style="width: 15%">Action Date</th>
                  <th style="width: 35%">Comment</th>
                </tr>
              </thead>
              <tbody v-for="(workflow, index) in wfDtl.wfHistory" :key="index">
                <tr>
                  <td style="width: 10%">{{workflow.action}}</td>
                  <td style="width: 25%">{{workflow.user_name}}</td>
                  <td style="width: 15%">{{previousAction(wfDtl.wfHistory,index)}}</td>
                  <td style="width: 15%">{{formatDateTime(workflow.action_on)}}</td>
                  <td style="width: 35%">{{workflow.note}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h4>Employee Detail</h4>
        </div>
        <div class="card-body">
          <div class="row">
            <Textbox
              readonly="true"
              title="Employee / Director name"
              v-model="formData.claimUser"
              class="col-sm-6"
            />

            <Textbox
              readonly="true"
              title="Date Claim Submitted"
              v-model="formData.staff_name"
              class="col-sm-6"
            />
          </div>
          <div class="row">
            <MobileSelectbox
                    title="Category:"
                    :readonly="view"
                    wrapperclass='col-12 col-md-6'
                    labelclass='col-3'
                    inputclass='col-9'
                    :options="lookups.Reim_or_cre"
                    :key="componentkey"
                    :nolabel="false"
                    v-model="formData.account_code"
                  />
            <!--<div class="row">
        <Textbox title="Approver" readonly="true" v-model="formData.staff_name" class="col-sm-6" />
      </div>
      <div class="row">
        <Textbox
          title="Date Approved"
          readonly="true"
          v-model="formData.staff_name"
          class="col-sm-6"
        />
      </div>
      <div class="row">
        <Textbox
          title="Finance Approval"
          readonly="true"
          v-model="formData.staff_name"
          class="col-sm-6"
        />
      </div>
      <div class="row">
        <Textbox
          title="Date Approved"
          readonly="true"
          v-model="formData.staff_name"
          class="col-sm-6"
        />
            </div>-->
            <Textbox
              title="Date Paid"
              readonly="true"
              v-model="formData.paidDate"
              class="col-sm-6"
              minDate="0"
            />
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h4>Clam Summary</h4>
        </div>
        <div class="card-body">
          <div class="row">
            <Textbox
              readonly="true"
              title="Item Counts"
              v-model="gridData.itemCount"
              class="col-sm-6"
            />

            <Textbox
              readonly="true"
              title="Total Net Amount"
              v-model="gridData.netAmount"
              class="col-sm-6"
            />
            <Textbox
              readonly="true"
              title="Total Gst Amount"
              v-model="gridData.gstAmount"
              class="col-sm-6"
            />
            <Textbox
              readonly="true"
              title="Total Gross Amount"
              v-model="gridData.grossAmount"
              class="col-sm-6"
            />
          </div>
          <!-- <hr v-if="formData.claimDetailList&&formData.claimDetailList.length!=0" /> -->

          <template>
            <div v-for="(b,index) in formData.claimDetailList" :key="b.id">
              <div class="card claimDetail">
                <div class="card-header">
                  <div class="container-fluid pl-0">
                    <div class="row" v-if="!view">
                      <div class="col-sm-auto buttonBar">
                        <a href="javascript:void(0)" @click="deleteButtonClick(index)">
                            <i class="fas fa-minus-circle" style="font-size: 24px;"></i>
                          </a>
                        <input :id="'name_' + (index+1)" :value="{index}" hidden />
                      </div>
                      <div class="col-sm-auto detailTitle">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <Datebox2 title="Date:" v-model="b.date" :id="'dateInput_'+index"
                    wrapperclass='col-12 col-md-2'
                    labelclass='col-12'
                    inputclass='col-12'
                    :readonly="view"
                    />

                  <!-- <div class="col-12 col-md-4">
                    <div class="row">
                      <label class="col-form-label col-12">Category:</label>
                      <div :class="'col-12'">
                        <select class="form-control" v-model="b.account_code" style="padding:5px;">
                          <option>Option 1</option>
                          <option>Option 2</option>
                          <option>Option 3</option>
                        </select>
                      </div>
                    </div>
                  </div> -->

                  <!-- TODO: change to selectbox -->
                  <MobileSelectbox
                    title="Category:"
                    wrapperclass='col-12 col-md-4'
                    labelclass='col-12'
                    inputclass='col-12'
                    :options="lookups.Reim_or_cre"
                    v-model="b.account_code"
                    :readonly="view"
                  />

                  <MobileTextbox
                    title="Net:"
                    wrapperclass='col-12 col-md-2'
                    labelclass='col-12'
                    inputclass='col-12'
                    :className="'netGroup'"
                    v-model="b.net"
                    type="number"
                    :readonly="view"
                  />
                  <MobileTextbox
                    title="Gst:"
                    wrapperclass='col-12 col-md-2'
                    labelclass='col-12'
                    inputclass='col-12'
                    :className="'gstGroup'"
                    v-model="b.gst"
                    :size="2"
                    type="number"
                    :readonly="view"
                  />
                  <MobileTextbox
                    title="Gross: "
                    wrapperclass='col-12 col-md-2'
                    labelclass='col-12'
                    inputclass='col-12'
                    :className="'grossGroup'"
                    v-model="b.gross"
                    :size="2"
                    type="number"
                    :readonly="view"
                  />
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="row">
                      <label class="col-form-label" :class="'col-12'">Description:</label>
                      <div class="col-12">
                        <textarea
                          class="form-control"
                          v-model="b.description"
                          rows="3"
                          style="min-height: 100px"
                          :readonly="view"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <label class="col-form-label ">Receipt:</label>
                    <button class="btn btn-info" style="float: right;" @click="clearFile(index)" v-if="!view">
                       Clear
                    </button>
                  </div>
                 
            
                  <!--<div class="col-sm-12">
                    <button type="button" class="btn btn-info btn-block" @click="reciplClick(b.id)">
                      <i class="fas fa-camera"></i> Upload / Take Photo
                    </button>
                  </div> -->
                  <div class="col-sm-12" >
                    <form action="/file-upload"
                      :id="'dropzone' + (index)"
                      class="dropzone" v-show="!view">
                    </form>
                  </div>
                  <div class="col-sm-12" v-if="!isMobile">
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Original Name</th>
                          <th scope="col">System Attachment ID</th>
                          <th scope="col" v-if="!view">Remove</th>
                          <th scope="col" v-if="!view">Download</th>
                        </tr>
                      </thead>
                      <tbody>
                          <tr v-for="(b2,index2) in formData.detailAttachmentList[index]" :key="b2.id">
                            <td>{{b2.id}}</td>
                            <td>{{b2.original_name}}</td>
                            <td>{{b2.sys_attachment_id}}</td>
                            <td v-if="!view"><button class="btn btn-danger btn-block" @click="removeDetailAttachment(index,index2)">
                              Remove
                            </button></td>
                            <td v-if="!view"><button class="btn btn-info btn-block" @click="DownloadAttachment(index,index2)">
                              Download
                            </button></td>
                          </tr>
                      </tbody>
                    </table>
                  </div>

                <div class="col-sm-12" v-if="isMobile">
                    <!-- <table class="table"> -->
                      <div style="padding: 5px 0px;background-color: #E3F3F3;" v-for="(b2,index2) in formData.detailAttachmentList[index]" :key="b2.id">
                            <label>File{{index2}}</label>
                            <label>ID: {{b2.id}}</label>
                            <label>Original Name: {{b2.original_name}}</label>
                            <label>System Attachment ID: {{b2.sys_attachment_id}}</label>
                            <button class="btn btn-danger" @click="removeDetailAttachment(index,index2)">
                              Remove
                            </button>
                            <button class="btn btn-info" style="float: right;" @click="DownloadAttachment(index,index2)">
                              Download
                            </button>
                          
                      </div>
                    <!-- </table> -->
                  </div>


                </div>
              </div>
            </div>
          </template>

          <button type="button" class="btn btn-info btn-block" @click="addButtonClicked()" v-if="!view">
            <i class="fas fa-plus-circle"></i> Add Detail
          </button>
        </div>
      </div>
    </div>
    <!-- <div class="section-body"> -->
      <div class="row" style="padding: 15px 25px;" v-if="!view">
        <CheckBox
          class="col-sm-8"
          title="Declare"
          v-model="formData.declare"
          :options="[
                { Key: 'true', Value: ' I, declare that the above expenses claimed are in accordance with the Legato Solutions Business Expense Policy and were incurred by me wholly for a valid MIC business purpose.' }
              ]"
        />
      <!-- </div>  -->
      <!-- <SlickGrid :gridId="gridId" :editable="false" :frozenColumn="2" :isModeManager="true" baseUrl="/claim_form" v-show="isShow"/> -->
    </div>

    <!--Submit Model-->
    <div
      id="wfDiagramModal"
      class="modal fade so-alert-dialog in"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg bootstrap-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div id="graph"></div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <!--Submit Model-->
    
  </div>
</template>
<style>
.claimDetail {
  border-color: #efefef;
  border-style: solid;
  border-width: 1px;
  border-radius: 8px;
  padding-top:0;
  padding-left:12px;
  padding-right:12px;
  padding-bottom: 8px;
}
.card.claimDetail .card-header {
  padding-left:0;
  padding-right:0;
}
</style>

<script>
import api from "@/api";
import { mapActions, mapGetters } from "vuex";
import helper from "@/vueHelper";
import config from "@/config";
import SelectBox from "@/components/selectbox";

export default {
  title: "Expense Claim Form",
  hidden: true,
  access_code: "F_FORM01",
  components: {SelectBox},
  data() {
    return {
      componentkey: 0,
      lookups: {Reim_or_cre: [{Key: "Reimbursement", Value: "Reimbursement"},{Key: "Company Credit card", Value: "Company Credit card"} ]},
      uploadLimit: config.fileUploadLimit * 1000000 || 10000000,
      file_first_index: null,
      myDropzone: [],
      detail_number: null,
      total_file_number_before_upload: 0,
      total_file_number_upload_success: 0,
      file: [],
      wfDtl: {},
      wfNote: null,
      gridId: "form01",
      formData: {
        declare: "",
        claimUser: "",
        paidDate: ""
      },
      gridData: {
        itemCount: 0,
        netAmount: 0,
        gstAmount: 0,
        grossAmount: 0
      },
      view:Boolean,
      deleteList: [],
      deleteFileList: [],
      ticon: false,
      isMobile:false
    };
  },
  created() {
    ////this.$route.meta.access_code = this.gridId;
    //helper.initFormGrid(this);

    if(this.$router.history.current.path.indexOf("/Mobile/")){
       this.isMobile=false;
       }else{
        this.isMobile=true;
        
    }
    console.log(this.isMobile);
  },
  computed: {
    ...mapGetters("grid", ["getGridById", "getViewMode"]),

    grid() {
      return _.cloneDeep(this.getGridById(this.gridId));
    },

    dataList() {
      return this.grid.data;
    },
    computedIcon() {
      if (this.icon == undefined) {
        return true;
      }

      return this.icon;
    }
  },
  mounted() {
    this.loadForm();
  },
  updated() {

  },

  methods: {
    ...mapActions("grid", [
      "actionResetGrid",
      "actionSetGrid",
      "actionRequest"
    ]),
    ...mapActions("filters", ["actionFindNow"]),
    wfAction(action) {
      let doSave = true;
      if (action && action.required_note) {
        doSave = false;
      }
      if (this.formData.declare) {
        if (
          this.formData.declare == true ||
          this.formData.declare[0] == "true"
        ) {
          this.saveButtonClicked(true, action.id, doSave);
        } else {
          helper.alert("Please apply the Declare");
        }
      } else {
        helper.alert("Please apply the Declare");
      }
    },
    wfNoteChanged(value) {
      this.wfNote = value;
    },
    allFileSent() {
      let copyForm = _.cloneDeep(this.formData);
      helper.join(copyForm, "declare");
      api.request(
        this,
        "post",
        `/claim_form/${this.gridId}_save`,
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
          //LocaleCode: this.$store.state.user.locale_code,
          Parameters: {
            id: this.$route.params.id,
            formData: copyForm,
            dataList: this.formData.claimDetailList,
            deleteList: this.deleteList,
            deleteFileList: this.deleteFileList,
            wfAction: this.wfAction,
            wfNote: this.wfNote,
            newFileList: this.file,
            detailAttachmentList: this.formData.detailAttachmentList
          }
        },
        function(r) {
          helper.clearData(this);
          this.deleteList = [];
          this.deleteFileList = [];
          this.$router.go(0);
        },
        function(r) {
          helper.done();
        },
        null
      );
    },
    loadForm() {
      //this.componentkey+=1
      var vm = this
      //helper.initFormGrid(this);
      helper.loading();
      api.request(
        this,
        "post",
        `/claim_form/${this.gridId}_load`,
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
          //LocaleCode: this.$store.state.user.locale_code,
          Parameters: {
            id: this.$route.params.id,
            preparer_user_userid: helper.getUserID(),
            actual_user_userid: helper.getUserID()
          }
        },
        function(r) {
          this.wfDtl = r.data.wfDtl;
          helper.split(r.data.formData, "declare");

          this.formData = r.data.formData;
          this.formData.claimUser = r.data.claimUser;
          this.formData.paidDate = r.data.paidDate;
          this.view=r.data.view;
          //console.log(r.data.formData.claimDetailList);
          // console.log(r.data.fromData);
          this.detail_number=0
          if (r.data.formData.claimDetailList != null) {
            this.formData.claimDetailList.forEach(obj => {
              this.gridData.itemCount += 1;
              this.gridData.netAmount += obj.net;
              this.gridData.gstAmount += obj.gst;
              this.gridData.grossAmount += obj.gross;
              this.detail_number+=1
              this.file.push([])
            });
          }
          // this.gridData.itemCount=0;
          // this.gridData.netAmount=0;
          // this.gridData.gstAmount=0;
          // this.gridData.grossAmount=0;

          //helper.findNow(this);
          if (this.formData.claimDetailList == null) {
            this.gridData.itemCount++;
            this.formData.claimDetailList = [];
            this.formData.claimDetailList.push({
              date: null,
              description: null,
              net: null,
              gst: null,
              gross: null
            });
            this.detail_number=1
            this.file.push([])
          }
          if (r.data.formData.detailAttachmentList != null){
            this.formData.detailAttachmentList = r.data.formData.detailAttachmentList
          }else{
            this.formData.detailAttachmentList = []
            this.formData.detailAttachmentList.push([])
          }
          setTimeout(() => {
          this.componentkey+=1
            
          }, 250);
          this.$nextTick(function () {
            
            // DOM is now updated
            // `this` is bound to the current instance
            Dropzone.options.myAwesomeDropzone = {
              paramName: "Files"
            };
            Dropzone.autoDiscover = false
            for(var i=0;i<this.detail_number;i++){
              this.myDropzone.push(
                new Dropzone("#dropzone"+i, {
                  paramName: "Files",
                  autoProcessQueue: false, 
                  url: config.serverURI + '/api' + '/claim_form/form01_file_save',
                  error: function (file, response) {
                      console.log("Error");
                      console.log(response);
                  },
                  success: function (file, response) {
                      console.log("Success");
                      vm.total_file_number_upload_success+=1
                      vm.file[response.data.detail_index].push({sys_attachment_id: response.data.sys_attach_id, original_name: response.data.org_file_name})
                      if(vm.total_file_number_upload_success == vm.total_file_number_before_upload){
                        vm.allFileSent();
                      }
                  },
                  complete: function (file) {
                      console.log("Complete");
                  },
                  init: function() {
                    var detail_index = i
                    this.on("sending", function(file, xhr, formData) {
                      formData.append("SessionID", helper.getSessionID());
                      formData.append("LocaleCode", helper.getLocaleCode());
                      formData.append("ApiKey", config.apiKey);
                      formData.append("ApiSystemName", config.apiSystemName);
                      var fileParams = []
                      fileParams.push({
                        refId: detail_index
                      });
                      formData.append("FileParams", JSON.stringify(fileParams));
                    });
                  }
              }));
            }
          })
          
          helper.done();

          this.loadGraph();
        },
        function(r) {
          helper.done();
        },
        null
      );
    },
    loadGraph() {
      var graph = new Graph(document.getElementById("graph"));
      graph.resizeContainer = true;
      graph.setEnabled(false);

      //var data = "7Vpdc6M2FP01ntk+lAEJMDz6c5tp15uJ0+32aUcG2WiDERUitvfXV4D4tj0bx4mhUzLjoCPpCumec7mSPYCT7f4jQ6H3ibrYHwDV3Q/gdADA0DLFZwIcMkDX7AzYMOJmkFYCS/IDS1CVaExcHNUackp9TsI66NAgwA7PMNkXMUZ3UQ1aU78+aog2uAUsHeS30b+Iy70MtQy1xH/DZOPJkTVNTWvgbAAnjFKe3W33E+wn65LPOes+P1FbDMpwwI90+DPC7PPqezJfoPpoJZY8bTQAxgJtsfgnDfjIwZ6YMmb11UpbpcCSI8YzcIojh5GQExq06n7H0n/Lx9HDY4YVT1vOuJhJxA/5CkYeCpPb7X6TMERZ+3TneMKywjHbkgBxygZwvPMIx8tQPLBouxMtBebxbTIzTdxGnNGnwgWwQCbUT7qLgaBtjg3LEDVr4vsVfGzP1FGCP6WTqMygusByZZ4x43hfgeS8PmK6xZwdRBNZq0sKHOrFXckSLWedV2GImZNTemRTGC79K27kSubFisevzYAH/Ezw7gQFviBG0MrHWosGs/sGC7SzLGA0DlyctFVf6mxwzNkjLfkTNdf3pGb11ZWjMGT0Gb/el+C/4kuoGT315SxwT/ixqCk8OFtMGw6E3QjJY8uGNmyH5Pl8Iq4iJBfPf03XG2ZfZbyMV1vCwam3clqbVa42Ex9FUT5SSgGRCbXAiCMeR1+QH+MqzLCDiVhgKWsUPH1YU7YdwBFyeIz8b7GYVPohiAUm2i+ym2hYNSNGdEn5gLntf2LCsLugvDYmijldchxWsYLIo8nj3edFg8v6WS5jV+RrskgZ9+iGBsiflei4Hq7KNn9QGkoqf8ecH2TymTxgnegnuRnRmDmNhFXkTBtcZIMZljzjWQZXKGocYWiOMewjLhxWe4hjtJUj3FMS8FIgmt1MWRrMz+Yje1Xz04ahVpQ1GoayRWgZSlVUTLtr78fbCQvcRlhGP4SVb/uqwgLdEpbWyCC1C4XVMmT3Q1gPODPzvrp6lWg4i/GlwjFvLRy8J/xr0l2xbVOW/07Lhm7I8nQv7aeFQ6VwL8KOYEq6jCkWCNZ8zU0nBWkLDnOgNJaWDtVS09zlqlY7pWoINcW01PIya9oUQUgBoFINL9M8hKpSsaJqtVGG5wf5Px50IR4MOxwPgP6KeKAkpK/HBB28XUwAr4gJUk2/qooOjfam/w3jhNhAKpbe1mh5BFHTdx5GXpx0m43sXVMMw65cxk+FhtJu3pCu1xHuVPgYOalej4ePauV103Tq4w/zu8VoMZl9G00/3S1ukpaD88fpnUnLj4gVdGu/C6yGYprZ9Ate0XVDej/S8jkJUCAcBtRrnQzXHNrrk2G9t1/YnPdlrbY76dWlwRD0IhiCY7sZ2Klg2DxagFYjX7j0jELvyeHf2T3JmyUVNxHN+W9/3nE/Umwgyv3IdXcj5tudUBzV9Mt3I8bQslovmvdMegxNMUHdyk9vOYZ1W6D5hcF77zEEVP6oJrNQ/uoIzv4F";
      var data = this.wfDtl.wfdesigner;
      if (data != null) {
        var wfdataraw = Graph.decompress(data);
        var xmlDoc = mxUtils.parseXml(wfdataraw);
        var codec = new mxCodec(xmlDoc);
        codec.decode(xmlDoc.documentElement, graph.getModel());

        var model = graph.getModel();
        var currentSelectedVertex = null;
        var isStartOrEnd = false;
        var lookupWord = this.wfDtl.curStep.description;
        for (const property in model.cells) {
          if (
            model.cells[property].value !== undefined &&
            model.cells[property].value.tagName == "UserObject"
          ) {
            if (model.cells[property].value.getAttribute("Key") == "STEP") {
              if (
                model.cells[property].value.getAttribute("Name") == lookupWord
              ) {
                currentSelectedVertex = model.cells[property];
                isStartOrEnd = false;
                break;
              }
            } else if (
              model.cells[property].value.getAttribute("Key") == "START" ||
              model.cells[property].value.getAttribute("Key") == "END"
            ) {
              if (
                model.cells[property].value.getAttribute("Name") == lookupWord
              ) {
                currentSelectedVertex = model.cells[property];
                isStartOrEnd = true;
                break;
              }
            }
          }
        }

        if (currentSelectedVertex != null) {
          //Adds animation to edge shape and makes "pipe" visible
          var state = graph.view.getState(currentSelectedVertex);
          if (isStartOrEnd) {
            state.shape.node
              .getElementsByTagName("path")[0]
              .removeAttribute("visibility");
            state.shape.node
              .getElementsByTagName("path")[0]
              .setAttribute("stroke-width", "4");
            state.shape.node
              .getElementsByTagName("path")[0]
              .setAttribute("stroke", "gray");
            state.shape.node
              .getElementsByTagName("path")[0]
              .setAttribute("class", "flow");
          } else {
            var state = graph.view.getState(currentSelectedVertex);
            state.shape.node
              .getElementsByTagName("rect")[0]
              .removeAttribute("visibility");
            state.shape.node
              .getElementsByTagName("rect")[0]
              .setAttribute("stroke-width", "4");
            state.shape.node
              .getElementsByTagName("rect")[0]
              .setAttribute("stroke", "gray");
            state.shape.node
              .getElementsByTagName("rect")[0]
              .setAttribute("class", "flow");
          }
        }
      }
    },

    saveButtonClicked(validate, actionId, doSave) {
      if (!helper.checkViewMode()) {
        return;
      }

      helper.loading();
      this.total_file_number_before_upload=0
      this.total_file_number_upload_success=0
      for(var i=0;i<this.myDropzone.length;i++){
        this.total_file_number_before_upload +=this.myDropzone[i].files.length
        this.myDropzone[i].processQueue();
      }
      if(this.total_file_number_before_upload == 0)
        this.allFileSent()
          
    },

    wfDiagramBtnClick() {
      $("#wfDiagramModal").modal("show");
    },
    cancelBtnClick() {
      this.$router.push("/FORMS/Form/list");
    },
    clearFile(index){
      this.myDropzone[index].removeAllFiles(true)
    },
    addButtonClicked() {
      var vm = this
      if (this.formData.claimDetailList) {
        this.gridData.itemCount++;
        this.formData.claimDetailList.push({
          date: null,
          description: null,
          net: null,
          gst: null,
          gross: null
        });
        this.formData.detailAttachmentList.push([])
        this.detail_number+=1
        this.$nextTick(function () {
          Dropzone.autoDiscover = false
          var i = this.detail_number - 1
          this.myDropzone.push(new Dropzone("#dropzone"+i, {
                  paramName: "Files",
                  autoProcessQueue: false, 
                  url: config.serverURI + '/api' + '/claim_form/form01_file_save',
                  error: function (file, response) {
                      console.log("Error");
                      console.log(response);
                  },
                  success: function (file, response) {
                      console.log("Success");
                      vm.total_file_number_upload_success+=1
                      vm.file[response.data.detail_index].push({sys_attachment_id: response.data.sys_attach_id, original_name: response.data.org_file_name})
                      if(vm.total_file_number_upload_success == vm.total_file_number_before_upload){
                        vm.allFileSent();
                      }
                  },
                  complete: function (file) {
                      console.log("Complete");
                  },
                  init: function() {
                    var detail_index = i
                    this.on("sending", function(file, xhr, formData) {
                      formData.append("SessionID", helper.getSessionID());
                      formData.append("LocaleCode", helper.getLocaleCode());
                      formData.append("ApiKey", config.apiKey);
                      formData.append("ApiSystemName", config.apiSystemName);
                      var fileParams = []
                      fileParams.push({
                        refId: detail_index
                      });
                      formData.append("FileParams", JSON.stringify(fileParams));
                    });
                  }
              }));
        })
        this.file.push([])
      }
    },
    reciplClick(id) {
      console.log(id);
    },
    removeDetailAttachment(index,index2){
      this.deleteFileList.push(this.formData.detailAttachmentList[index][index2])
      this.formData.detailAttachmentList[index].splice(index2, 1);
    },
    DownloadAttachment(index,index2){
      api.request(
        this,
        "post",
        `/claim_form/downloadfile`,
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
          //LocaleCode: this.$store.state.user.locale_code,
          Parameters: {
            Attachment: this.formData.detailAttachmentList[index][index2]
          }
        },
        function(r) {
          helper.done();
        },
        function(r) {
          helper.done();
        },
        null,
        'blob'
      );
    },
    deleteButtonClick(index) {
      this.gridData.itemCount--;
      if (this.formData.claimDetailList[index].id != null) {
        this.deleteList.push(this.formData.claimDetailList[index]);
      }
      this.formData.claimDetailList.splice(index, 1);
      for(var i=0;i<this.formData.detailAttachmentList[index].length;i++)
        this.deleteFileList.push(this.formData.detailAttachmentList[index][i])
      this.formData.detailAttachmentList.splice(index, 1);
      this.file.splice(index, 1);
      this.myDropzone.splice(index, 1);
      this.detail_number-=1
    },
    toggleIcon() {
      this.ticon = !this.ticon;
    },
    formatDateTime(d) {
      return moment.utc(d).format(config.momentDateTimeFormat);
    },
    previousAction(workflows, index) {
      if (workflows.length - 1 == index) {
        return moment
          .utc(workflows[index].action_on)
          .format(config.momentDateTimeFormat);
      } else {
        return moment
          .utc(workflows[index + 1].action_on)
          .format(config.momentDateTimeFormat);
      }
    },
  }
};
</script>


<style scoped>
.section-body {
  padding-top: 100px;
}
</style>